export default __webpack_public_path__ + "assets/webgl/aim_target.0ac41660.gltf";